import search from '@/components/wai/search/index.vue'
import searchsymptoms from '@/components/wai/searchsymptoms/index.vue'
import summarysymptoms from '@/components/wai/summarysymptomscorona/index.vue'

var colors = ['#FF150E', '#183BFF', '#D835FF', '#26FF00', '#FF4300', '#2985FF', '#E89C87', '#020830', '#0C332C']

export default {
    name: 'mainpage',
    components: {

        search,
        searchsymptoms,
        summarysymptoms
        
    },

    data : function(){

        return {
            lastchange : null,
            colors : {

            },
            symptoms : [
                {
                    CUI: "C9999999",
                    Name: "Covid-19",
                    STY: "Disease or Syndrome",
                    Popularity: 9999,
                    CUIName: "Covid-19",
                    unremovable : true
                },
                {
                    CUI: "C1175743",
                    Name: "SARS coronavirus",
                    STY: "Virus",
                    Popularity: 4523,
                    CUIName: "SARS coronavirus",
                },

                
                /*{
                    CUI: "C0150312",
                    CUIName: "Presence of",
                    STY: "Finding",
                    Popularity: 2187470
                },
                {
                    CUI: "C0243095",
                    CUIName: "Finding",
                    STY: "Finding",
                    Popularity: 2153072
                }*/
            ],

            //results : {"dec":[{"Name":"disease (or disorder); cardiovascular","CUI":"C0007222","p":"9.653629e-07"},{"Name":"Diabetes","CUI":"C0011847","p":"9.580976e-06"},{"Name":"Borderline hypertension","CUI":"C0262395","p":"9.557878e-08"},{"Name":"Obesity","CUI":"C0028754","p":"9.253345e-07"},{"Name":"sclerosis; cardiac","CUI":"C0010054","p":"9.2467594e-08"},{"Name":"Cardiovascular morbidity","CUI":"C1301700","p":"8.374746e-08"},{"Name":"Disorder of pregnancy","CUI":"C0151864","p":"8.118383e-08"},{"Name":"Sleep apnea","CUI":"C0037315","p":"7.2939923e-07"},{"Name":"Chro irreversible airway obstr","CUI":"C0024117","p":"7.268595e-06"},{"Name":"LUNG DIS","CUI":"C0024115","p":"6.441614e-08"},{"Name":"Heart valve disease","CUI":"C0018824","p":"6.4329946e-08"},{"Name":"Conn Syndrome","CUI":"C1384514","p":"6.431915e-08"},{"Name":"Hyperhomocysteinemia","CUI":"C0598608","p":"6.173384e-08"},{"Name":"Renal Insufficiency","CUI":"C1565489","p":"6.0716495e-08"},{"Name":"COB - Chron obstruc bronchitis","CUI":"C0155874","p":"5.976195e-08"},{"Name":"Sleep Apnea, Obstructive","CUI":"C0520679","p":"5.974141e-07"},{"Name":"Respiration Disorders","CUI":"C0035204","p":"5.8759166e-08"},{"Name":"CEREBRAL VASCULAR DISTURBANCE (NOS)","CUI":"C0007820","p":"5.743221e-07"},{"Name":"Severe chronic obstructive pulmonary disease","CUI":"C0730607","p":"5.6026163e-08"},{"Name":"Isolated systolic hypertension","CUI":"C0745133","p":"5.5876494e-06"},{"Name":"Hypercholesterolemia","CUI":"C0020443","p":"5.5551136e-05"},{"Name":"Endothelial dysfunction","CUI":"C0856169","p":"5.5225064e-07"},{"Name":"Left ventricular diastolic dysfunction","CUI":"C1273070","p":"5.4578937e-08"},{"Name":"Renal Artery Stenosis","CUI":"C0035067","p":"5.4207835e-08"},{"Name":"Renal failure, chronic","CUI":"C0022661","p":"4.977098e-07"},{"Name":"Malignant Hypertension","CUI":"C0020540","p":"4.3670855e-08"},{"Name":"LVH - Left ventricular hypertrophy","CUI":"C0149721","p":"4.2774204e-07"},{"Name":"Nephrosclerosis","CUI":"C0027719","p":"4.1779197e-07"},{"Name":"NEPHROPATHY","CUI":"C0022658","p":"4.168763e-08"},{"Name":"sexual impotence","CUI":"C0242350","p":"3.7936488e-07"},{"Name":"Hyperuricemia","CUI":"C0740394","p":"3.6867127e-07"},{"Name":"Heart Failure, Diastolic","CUI":"C1135196","p":"3.6720927e-08"},{"Name":"Chronic glomerulonephritis","CUI":"C0152451","p":"3.4311988e-08"},{"Name":"coronary disease","CUI":"C0010068","p":"3.4127552e-07"},{"Name":"Chronic Kidney Insufficiency","CUI":"C0403447","p":"3.3770494e-08"},{"Name":"White Coat Hypertension","CUI":"C0262534","p":"3.297542e-05"},{"Name":"Periodontitis","CUI":"C0031099","p":"3.068097e-07"},{"Name":"Lung Diseases, Obstructive","CUI":"C0600260","p":"2.9152008e-07"},{"Name":"DIABETES MELLITUS, TYPE 2","CUI":"C0011860","p":"2.5260812e-07"},{"Name":"Congestive heart failure (CHF)","CUI":"C0018802","p":"2.3331593e-07"},{"Name":"cardiovascular risk factor","CUI":"C0850624","p":"2.2682798e-06"},{"Name":"Systolic hypertension","CUI":"C0221155","p":"2.2476946e-05"},{"Name":"cardiopathy","CUI":"C0018799","p":"2.2107528e-07"},{"Name":"pvd","CUI":"C0085096","p":"2.21066e-07"},{"Name":"Hypertensive Retinopathy","CUI":"C0152132","p":"2.136479e-07"},{"Name":"Diastolic hypertension","CUI":"C0235222","p":"2.0684984e-05"},{"Name":"Chronic Bronchitis","CUI":"C0008677","p":"2.0427303e-06"},{"Name":"Dyslipidemias","CUI":"C0242339","p":"1.9638612e-05"},{"Name":"Diabetes","CUI":"C0011849","p":"1.897399e-05"},{"Name":"end organ damage","CUI":"C0743496","p":"1.8644086e-07"},{"Name":"Periodontal Diseases","CUI":"C0031090","p":"1.8576253e-07"},{"Name":"VASCULAR (EXTRACARDIAC) DISORDERS","CUI":"C0042373","p":"1.7249243e-07"},{"Name":"Maternal hypertension","CUI":"C0565599","p":"1.605903e-07"},{"Name":"Ischaemic heart disease","CUI":"C0151744","p":"1.4937602e-07"},{"Name":"Primary hypertension","CUI":"C0085580","p":"1.3546403e-06"},{"Name":"Secondary hypertension","CUI":"C0155616","p":"1.3438755e-06"},{"Name":"HP:0000833","CUI":"C0271650","p":"1.3120355e-07"},{"Name":"Renal vascular disorder","CUI":"C0268790","p":"1.2822046e-07"},{"Name":"Carotid Atherosclerosis","CUI":"C0577631","p":"1.2602017e-07"},{"Name":"Hyperlipidemia","CUI":"C0020473","p":"1.2457516e-05"},{"Name":"Uncomplicated hypertension","CUI":"C0497248","p":"1.07492035e-07"}],"proc":[{"Name":"Serum urate measurement","CUI":"C0455272","p":"9.056158e-08"},{"Name":"heart study","CUI":"C0489835","p":"8.1715136e-08"},{"Name":"Blood Pressure Monitoring, Ambulatory","CUI":"C0242876","p":"5.229572e-07"},{"Name":"Serum total cholesterol measurement","CUI":"C1445957","p":"4.5476114e-08"},{"Name":"Albumin To Creatinine Protein Ratio Measurement","CUI":"C0486293","p":"4.3469495e-08"},{"Name":"Blood Pressure Monitoring, Home","CUI":"C1449681","p":"4.1431244e-06"},{"Name":"Albumin/creatinine ration result","CUI":"C1318293","p":"4.118868e-08"},{"Name":"Body mass index procedure","CUI":"C0005893","p":"3.9543735e-08"},{"Name":"Urine albumin:creatinine ratio result","CUI":"C1318330","p":"3.3834322e-08"},{"Name":"Oscillometry","CUI":"C0029375","p":"2.0513737e-07"},{"Name":"Finding of serum lipid levels","CUI":"C1287373","p":"1.4763434e-07"},{"Name":"Glucose tolerance test positive","CUI":"C0159069","p":"1.0329209e-07"}],"ther":[{"Name":"Antihypertensive therapy","CUI":"C0585941","p":"7.03854e-07"},{"Name":"Nicotine replacement therapy","CUI":"C1278444","p":"6.8334766e-06"},{"Name":"Angiotensin converting enzyme inhibitor therapy","CUI":"C1444755","p":"5.0705477e-08"},{"Name":"Na - Low sodium diet","CUI":"C0012169","p":"2.3256908e-07"}],"drug":[{"Name":"Nicotine Chewing Gum","CUI":"C0599654","p":"8.7720105e-07"},{"Name":"ACE INHIBITORS","CUI":"C0003015","p":"7.60316e-08"},{"Name":"Nicotine Transdermal Patch","CUI":"C0358855","p":"5.1265937e-07"},{"Name":"Calcium channel blocker product","CUI":"C0006684","p":"4.4273705e-08"},{"Name":"antihypertensives (medication)","CUI":"C0003364","p":"1.7930296e-06"}],"sym":[{"Name":"Undiagnosed","CUI":"C1408353","p":"9.6944035e-08"},{"Name":"Symptom aggravating factors","CUI":"C0436331","p":"9.133281e-08"},{"Name":"medication use","CUI":"C0240320","p":"8.852043e-08"},{"Name":"Not pregnant (finding)","CUI":"C0232973","p":"7.3459965e-08"},{"Name":"new onset","CUI":"C0746890","p":"7.1768426e-07"},{"Name":"Snore","CUI":"C0037384","p":"6.520754e-08"},{"Name":"Drinking habits","CUI":"C0556303","p":"6.5043355e-07"},{"Name":"Obesity, Abdominal","CUI":"C0311277","p":"5.923835e-07"},{"Name":"Poor oral hygiene","CUI":"C0457640","p":"5.5933697e-08"},{"Name":"Sedentary lifestyle","CUI":"C1532253","p":"5.272518e-07"},{"Name":"Increased body mass index","CUI":"C0231254","p":"4.9349737e-08"},{"Name":"Refractory hypertension","CUI":"C0860493","p":"4.8462493e-07"},{"Name":"Dry cough","CUI":"C0850149","p":"4.6258034e-08"},{"Name":"Patient currently pregnant","CUI":"C0549206","p":"4.5136165e-08"},{"Name":"Low income","CUI":"C1331016","p":"4.4252094e-08"},{"Name":"proteinuria albuminuria","CUI":"C0001925","p":"4.4175962e-07"},{"Name":"diabetes status","CUI":"C1317301","p":"4.397695e-08"},{"Name":"Chesty cough","CUI":"C0239134","p":"4.3971834e-08"},{"Name":"Normal renal function","CUI":"C0232805","p":"4.2201567e-08"},{"Name":"Erythrocytosis","CUI":"C1527405","p":"3.887301e-08"},{"Name":"Diabetic","CUI":"C0241863","p":"3.7657184e-08"},{"Name":"risk factors","CUI":"C0035648","p":"3.7474404e-08"},{"Name":"Decreased HDL cholesterol concentration","CUI":"C0151691","p":"3.6516074e-08"},{"Name":"Abnormal glucose tolerance","CUI":"C0235401","p":"3.381129e-08"},{"Name":"Impaired lung function","CUI":"C0858943","p":"3.2866613e-08"},{"Name":"NICOTINE EXPOSURE","CUI":"C0240502","p":"3.0120677e-07"},{"Name":"Proteinuria","CUI":"C0033687","p":"2.9748304e-07"},{"Name":"Overweight","CUI":"C0497406","p":"2.3653311e-07"},{"Name":"Current non-drinker of alcohol","CUI":"C0457801","p":"1.7967706e-07"},{"Name":"Increase in blood pressure","CUI":"C0497247","p":"1.759229e-05"},{"Name":"Cigarette consumption","CUI":"C0459840","p":"1.6630618e-05"},{"Name":"Cardiovascular event","CUI":"C1320716","p":"1.6473696e-07"},{"Name":"Comorbidity","CUI":"C0009488","p":"1.2927097e-07"},{"Name":"Alcohol intake above recommended sensible limits","CUI":"C0560219","p":"1.2459166e-07"},{"Name":"Microalbuminuria","CUI":"C0730345","p":"1.2118253e-06"},{"Name":"Systemic arterial pressure","CUI":"C1272641","p":"1.1022541e-06"},{"Name":"Non-smoker","CUI":"C0337672","p":"0.16018331"},{"Name":"Former smoker","CUI":"C0337671","p":"0.07126418"},{"Name":"Cigarette smoker (finding)","CUI":"C0337667","p":"0.0026571169"},{"Name":"Hypertensive (finding)","CUI":"C0857121","p":"0.00091062684"},{"Name":"Tobacco Smoking History","CUI":"C1519384","p":"0.0004644148"},{"Name":"Encounter due to tobacco use","CUI":"C0040335","p":"0.00011518468"}]},
            //actual : true
            results : null,
            actual : false,

            resulthistory : []
        }

    },

    computed : {
        height : function(){
            return window.innerHeight / 2
        },
        leveldifference : function(y, dl){

            if(!dl) dl = 0;

            var l = this.resulthistory.length - 1 - dl

            var prel = l - 1;
            var diff = null

            var h = this.resulthistory

            if (prel >= 0 && h.length > l){

                diff = {
                    a : [],
                    b : []
                }

                if(h[l].addedcui){
                    var r = _.find(this.symptoms, function(c){
                        return c.CUI == h[l].addedcui.cui
                    }) 

                    if(r) diff.r = r
                }

                _.each(h[l].results, function(r){

                    if(!_.find(h[prel].results, function(l){
                        return l.CUI == r.CUI
                    })) {

                        diff.a.push(r)
                    }

                })

                _.each(h[prel].results, function(r){

                    if(!_.find(h[l].results, function(l){
                        return l.CUI == r.CUI
                    })) {

                        diff.b.push(r)
                    }

                })
            }

            console.log('diff', diff)

            return diff
        },
    },

    mounted : function(){
        this.$refs.searchsymptoms.search()
    },

    methods : {

        applyactual : function(){
            this.actual = false
        },

        searchSelectAndGo : function(result){
            this.symptoms.push(result)
            this.actual = false
            this.$refs.searchsymptoms.search()
        },

        searchSelect : function(result){
            this.symptoms.push(result)
            this.actual = false

            this.$refs.searchsymptoms.search()
        },

        applyresults : function(results){
            this.actual = true

            var g = this.$f.group(results, function(f){
                return f.STY
            })

            var res = [];

            _.each(g, function(r){
                _.each(r, function(r, i){
                    if (i < 20){
                        res.push(r)
                    }
                })
            })

            this.results = res

            var cuis = _.map(this.symptoms, function(s){
                return s.CUI
            })

            var addedcui = null;

            var id = cuis.join('')

            var i = _.findIndex(this.resulthistory, function(f){
                return f.id == id
            })

            var cs = this.colors

            var t = this

            if (i > -1){
                
                var removed = this.resulthistory.splice(i)

                _.each(removed, function(r){

                    if(r.addedcui && r.addedcui.color){
                        t.$delete(t.colors, r.addedcui.color);
                    }

                })
            }
            

            if (this.resulthistory.length > 0){
                var last = this.resulthistory[this.resulthistory.length - 1]

                if (last){

                    if(last.cuis.length > cuis.length){

                        //this.resulthistory = []

                        var removed = this.resulthistory.splice(this.resulthistory.length - 2)

                        _.each(removed, function(r){

                            if(r.addedcui && r.addedcui.color){
                                t.$delete(t.colors, r.addedcui.color);
                            }

                        })

                        /*_.each(cs, function(c, i){
                            t.$delete(t.colors, i);
                        })*/

                    }

                    else{
                        var ac = _.filter(cuis, function(c){
                            return !_.find(last.cuis, function(cc){
    
                                if(cc == c) return true
    
                            })
                        })
    
                        if(ac[0]){
    
                            var color = _.find(colors, function(color){
                                return !cs[color]
                            })
    
                            //cs[color] = ac[0]
    
                            t.$set(t.colors, color, ac[0]);
    
                            addedcui = {
                                cui : ac[0],
                                color : color
                            }
                        }
                    }
                   
                    
                    
                }
            }

            console.log('this.resulthistory', this.resulthistory)

            this.resulthistory.push({
                cuis : cuis,

                id : id,

                addedcui : addedcui,

                results : this.results
            })

            var reshis = this.resulthistory


            _.each(this.results, function(result){
                return _.find(reshis, function(rh){

                    var rf = _.find(rh.results, function(rh){
                        if(rh.CUI == result.CUI) return true
                    })

                    if(rf){

                        if(rh.addedcui && rh.addedcui.color){
                            result.color = rh.addedcui.color
                        }

                        return true
                    }

                })
            })
        },

        toresult : function(cui){
            this.$refs.summarysymptoms.toresult(cui)
        }
    }
}